var map = {
	"./Barracks.png": 20273,
	"./Blood Platforms.png": 99010,
	"./Cave Altar.png": 60631,
	"./Dark Magic Library.png": 7224,
	"./Dark Ritual Room.png": 95970,
	"./Death Altar.png": 73760,
	"./Demon Throne.png": 15861,
	"./Four Rooms.png": 87368,
	"./Four Route.png": 41271,
	"./Goblin Prisons A.png": 68396,
	"./Icicle Cave.png": 11154,
	"./Old Tomb.png": 20127,
	"./Prisons B.png": 53452,
	"./Pyramid_crypts.png": 67572,
	"./Pyramid_ice cavern.png": 60923,
	"./Stone Graves A.png": 49110,
	"./Waiting Room.png": 56434,
	"./Wolf Cave.png": 98465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10639;